import React from 'react';
import PropTypes from 'prop-types';
import styles from '../ArticleComponents.module.css';

import L from 'leaflet';

export default class MapComponent extends React.Component {
	state = {};

	componentDidMount() {
		const { component, id } = this.props;
		let { lat, lng, zoom } = component;

		if (typeof lat === 'string') {
			lat = parseFloat(lat);
		}
		if (typeof lng === 'string') {
			lng = parseFloat(lng);
		}

		try {
			this.map = L.map(id, {
				center: [lat, lng],
				tap: false,
				zoom,
				layers: [
					L.tileLayer(
						'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
						{
							attribution:
								'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
						}
					),
				],
			});

			const marker = L.marker([lat, lng]);
			marker.addTo(this.map);
		} catch (e) {
			console.error(e);
		}
	}

	render() {
		const { id, readerMode, mediaStyle } = this.props;
		if (readerMode) {
			return null;
		}
		const containerStyle = {};
		if(mediaStyle?.component_bottom_margin) {
			containerStyle.marginBottom = `${mediaStyle.component_bottom_margin}px`
		}
		return (
			<div style={containerStyle} className={`${styles['component-map']}`}>
				<div id={id} />
			</div>
		);
	}
}

MapComponent.propTypes = {
	component: PropTypes.object.isRequired,
	id: PropTypes.string.isRequired,
	readerMode: PropTypes.bool,
	mediaStyle: PropTypes.object
};
